module.exports = __webpack_public_path__ + "media/images/flags/uz-3591058cc0de313a8ab0197891a6a290.svg";